<script setup lang="ts">
import CheckboxInput from "./Inputs/CheckboxInput.vue";
import TransitionHeight from "./TransitionHeight.vue";
import RadioInput from "~/components/Common/Inputs/RadioInput.vue";

function updateModelValue(select: boolean) {
  emit("update:modelValue", select);
}

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: Boolean,
  },
  isRadio: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

function toggleCheckbox() {
  if (!props.disabled) updateModelValue(!props.modelValue);
}
</script>

<template>
  <div class="container" :class="{ active: isRadio && modelValue, disabled: props.disabled }">
    <div
      class="flex justify-between w-full gap-4 items-center cursor-pointer"
      :class="{ 'pb-3 border-header  mb-2': modelValue && $slots.body }"
      @click="toggleCheckbox"
    >
      <slot name="headers"></slot>
      <CheckboxInput
        v-if="!isRadio"
        class="min-w-[16px] min-h-[16px]"
        :checked="modelValue"
        :value="modelValue"
        :disabled="disabled"
        @update:model-value="updateModelValue($event)"
      ></CheckboxInput>
      <RadioInput v-if="isRadio" class="min-w-[16px] min-h-[16px]" :checked="modelValue" :disabled="disabled">
      </RadioInput>
    </div>
    <TransitionHeight :duration="300">
      <div v-if="modelValue && $slots.body" class="body-accordion border-body-accordion">
        <slot name="body"></slot>
      </div>
    </TransitionHeight>
  </div>
</template>

<style scoped lang="scss">
.container {
  @apply flex p-4 flex-col items-start self-stretch rounded-[8px];
  border: 1px solid var(--grey-lightest);

  &:hover {
    cursor: pointer;
    border-color: var(--blue-medium);
  }
  &.disabled {
    border-color: var(--grey-lightest);
  }

  &.disabled:hover {
    border-color: var(--grey-lightest);
  }
}

.active {
  border-color: var(--blue-medium);
}

.border-header {
  border-bottom: 1px solid var(--grey-lightest);
}

.body-accordion {
  @apply pt-2 w-full cursor-default;
}
</style>
